import { MappingTables } from '@import/types/mapping-tables.types';

/*
 * Move the Banking fields to Default Required if Company Settings
 * requires collecting banking information for all employees
 */
export const moveJobAndPayBankingFieldsToDefaultRequired = (mappingTables: MappingTables) => {
    const jobAndPaySections = { ...mappingTables.jobAndPay.sections };

    // Remove Banking Fields from Job & Pay sections
    delete mappingTables.jobAndPay.sections.banking;

    // Add Banking Fields to Default Required Section
    mappingTables.defaultRequired.sections.default = [
        ...mappingTables.defaultRequired.sections.default,
        ...jobAndPaySections.banking,
    ];

    return mappingTables;
};
